module.exports = __webpack_public_path__ + "img/p2-61.a5954c2a.png";